import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { INotification } from '@/models/Notification';
import { v4 as uuidv4 } from 'uuid';

@Module({ namespaced: true, name: 'NotificationModule' })
export default class NotificationModule extends VuexModule {

  public notifications: Array<INotification> = [];

  @Mutation
  public ADD_NOTIFICATION(notification: INotification): void {
    notification.id = uuidv4();
    this.notifications = this.notifications.concat(notification);
  }

  @Mutation
  public REMOVE_NOTIFICATION(notificationToDelete: INotification): void {
    this.notifications = this.notifications.filter(x => x.id !== notificationToDelete.id);
  }

  @Action({ commit: 'ADD_NOTIFICATION', rawError: true })
  public async add(notification: INotification): Promise<INotification> {
    notification.show = true;
    notification.color = notification.color || 'success';
    notification.timeout = notification.timeout || 6000;
    return notification;
  }

  @Action({ commit: 'REMOVE_NOTIFICATION', rawError: true })
  public async remove(notification: INotification): Promise<INotification> {
    return notification;
  }

  public get activeNotifications(): Array<INotification> { 
    return this.notifications.filter(x => x.show === true);
  }
}
